
import { useEffect } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { CategorySection } from "@/components/home/CategorySection";
import { FeaturedStories } from "@/components/home/FeaturedStories";
import { AuthorCTA } from "@/components/home/AuthorCTA";
import { SubscriptionCTA } from "@/components/home/SubscriptionCTA";

const IndexPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "ChapterSeed - Episodic Digital Stories";
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex flex-col">
        <HeroSection />
        <CategorySection />
        <FeaturedStories />
        <AuthorCTA />
        <SubscriptionCTA />
      </main>
      <Footer />
    </div>
  );
};

export default IndexPage;
